"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dbGuide = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var DbGuideState_1 = require("@/pages/dbguide/states/DbGuideState");
var MegaMenu_1 = require("@/pages/common/components/MegaMenu");
var classNames = require("classnames");
var DbGuideAction_1 = require("@/pages/dbguide/actions/DbGuideAction");
var myokay_map_1 = require("@okay/myokay-map");
var DbGuidePlaceDevelopmentView_1 = require("@/pages/dbguide/components/DbGuidePlaceDevelopmentView");
var DbGuidePlaceSchoolView_1 = require("@/pages/dbguide/components/DbGuidePlaceSchoolView");
var DbGuidePlaceEmergencyView_1 = require("@/pages/dbguide/components/DbGuidePlaceEmergencyView");
var DbGuidePlaceTransportView_1 = require("@/pages/dbguide/components/DbGuidePlaceTransportView");
var DbGuidePlaceSportView_1 = require("@/pages/dbguide/components/DbGuidePlaceSportView");
var DbGuidePlaceUsefulLinkView_1 = require("@/pages/dbguide/components/DbGuidePlaceUsefulLinkView");
var DbGuidePlaceBusinessDirectoryView_1 = require("@/pages/dbguide/components/DbGuidePlaceBusinessDirectoryView");
var Login_1 = require("@/pages/common/components/Login");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.dbGuide), { layout: state.layout })); };
var mapDispatchToProps = function (dispatch) { return ({
    onViewMapClicked: function () { return dispatch(DbGuideAction_1.default.onViewMapClicked()); },
    onPanelToggleClicked: function () { return dispatch(DbGuideAction_1.default.onPanelToggleClicked()); },
    onMapReady: function () { return dispatch(DbGuideAction_1.default.onMapReady()); },
    onMenuItemClick: function (menuItem, state) {
        return dispatch(DbGuideAction_1.default.onMenuItemClick(menuItem, state));
    },
    resetMap: function () { return dispatch(DbGuideAction_1.default.resetMap()); },
    onSliderPrevClick: function () { return dispatch(DbGuideAction_1.default.onSliderPrevClick()); },
    onSliderNextClick: function () { return dispatch(DbGuideAction_1.default.onSliderNextClick()); },
    onBackClick: function () { return dispatch(DbGuideAction_1.default.onBackClick()); },
    onPlaceClick: function (place) { return dispatch(DbGuideAction_1.default.onPlaceClick(place)); },
    onRouteClick: function (route) { return dispatch(DbGuideAction_1.default.onRouteClick(route)); },
    onSectionTitleClick: function (section) {
        return dispatch(DbGuideAction_1.default.onSectionTitleClick(section));
    },
    onMouseEvent: function (eventName, item) {
        return dispatch(DbGuideAction_1.default.onMouseEvent(eventName, item));
    },
}); };
exports.dbGuide = function (props) {
    var welcomeActionClass = classNames([
        'c-guides__actionbtn',
        {
            'u-hidden': !props.showWelcome,
        },
    ]);
    var nonWelcomeActionClass = classNames([
        'c-guides__actionbtn',
        {
            'u-hidden': props.showWelcome,
        },
    ]);
    var leftPanelMainClass = classNames([
        'l-leftpanel__main',
        {
            'l-leftpanel__main--welcome': props.showWelcome,
        },
    ]);
    var leftPanelClass = classNames([
        'l-leftpanel',
        {
            'l-leftpanel--fullscreen': props.hidePanel,
        },
    ]);
    var detailClass = classNames([
        'c-guides__detail',
        {
            'u-hidden': props.detailHidden,
            'c-guides__detail--active': props.detailActive,
        },
    ]);
    var accordianClass = classNames([
        'c-guides__accordian',
        {
            'u-hidden': props.accordianHidden,
            'c-guides__accordian--active': props.accordianActive,
        },
    ]);
    var onIsReady = function () {
        props.onMapReady();
    };
    var renderMenuItemChildrenItem = function (menuItem, index) {
        return (React.createElement("dd", { onClick: onMenuItemClick(menuItem), key: index }, menuItem.title));
    };
    var renderMenuItemChildren = function (childrenItems) {
        if (!childrenItems || !childrenItems.length)
            return;
        return childrenItems.map(function (it, i) { return renderMenuItemChildrenItem(it, i); });
    };
    var onMenuItemClick = function (menuItem) { return function () {
        props.onMenuItemClick(menuItem);
    }; };
    var onResetClick = function () {
        props.resetMap();
    };
    var onMouseevent = function (eventName, item) {
        props.onMouseEvent(eventName, item);
    };
    var onDevelopmentsFilterClick = function () {
        var item = props.menu.items.find(function (it) { return it.key === 'developments'; });
        var IS_OPEN = true;
        props.onMenuItemClick(item, IS_OPEN);
    };
    var onSchoolsFilterClick = function () {
        var item = props.menu.items.find(function (it) { return it.key === 'schools'; });
        var IS_OPEN = true;
        props.onMenuItemClick(item, IS_OPEN);
    };
    var onSportsFilterClick = function () {
        var item = props.menu.items.find(function (it) { return it.key === 'sport'; });
        var IS_OPEN = true;
        props.onMenuItemClick(item, IS_OPEN);
    };
    var renderMenuItem = function (menuItem, index) {
        var menuItemClass = menuItem.isOpened ? 'c-guides__accordianitem--active' : '';
        return (React.createElement("dl", { className: menuItemClass, key: index },
            React.createElement("dt", { onClick: onMenuItemClick(menuItem) },
                React.createElement("span", null,
                    React.createElement("span", { className: menuItem.icon }),
                    menuItem.title)),
            menuItem.children ? renderMenuItemChildren(menuItem.children) : null));
    };
    var renderMenu = function (props) {
        if (!props.menu || !props.menu.items.length)
            return;
        return props.menu.items.map(function (it, i) { return renderMenuItem(it, i); });
    };
    var renderCurrentPlace = function (props) {
        if (!props.currentPlace)
            return;
        if (props.currentPlace.type === DbGuideState_1.DbGuidePlaceType.DEVELOPMENT) {
            return (React.createElement(DbGuidePlaceDevelopmentView_1.DbGuidePlaceDevelopmentView, __assign({}, props.currentPlace, { onSliderPrevClick: props.onSliderPrevClick, onSliderNextClick: props.onSliderNextClick, onBackClick: props.onBackClick, onPlaceClick: props.onPlaceClick, onViewMap: props.onPanelToggleClicked })));
        }
        if (props.currentPlace.type === DbGuideState_1.DbGuidePlaceType.SCHOOL) {
            return (React.createElement(DbGuidePlaceSchoolView_1.DbGuidePlaceSchoolView, __assign({}, props.currentPlace, { onSliderPrevClick: props.onSliderPrevClick, onSliderNextClick: props.onSliderNextClick, onBackClick: props.onBackClick, onViewMap: props.onPanelToggleClicked })));
        }
        if (props.currentPlace.type === DbGuideState_1.DbGuidePlaceType.EMERGENCY) {
            return (React.createElement(DbGuidePlaceEmergencyView_1.DbGuidePlaceEmergencyView, __assign({}, props.currentPlace, { onBackClick: props.onBackClick, onSectionTitleClick: props.onSectionTitleClick })));
        }
        if (props.currentPlace.type === DbGuideState_1.DbGuidePlaceType.TRANSPORT) {
            return (React.createElement(DbGuidePlaceTransportView_1.DbGuidePlaceTransportView, __assign({}, props.currentPlace, { onBackClick: props.onBackClick, onSliderPrevClick: props.onSliderPrevClick, onSliderNextClick: props.onSliderNextClick, onRouteClick: props.onRouteClick })));
        }
        if (props.currentPlace.type === DbGuideState_1.DbGuidePlaceType.SPORT) {
            return (React.createElement(DbGuidePlaceSportView_1.DbGuidePlaceSportView, __assign({}, props.currentPlace, { onBackClick: props.onBackClick, onSliderPrevClick: props.onSliderPrevClick, onSliderNextClick: props.onSliderNextClick, onViewMap: props.onPanelToggleClicked })));
        }
        if (props.currentPlace.type === DbGuideState_1.DbGuidePlaceType.USEFUL_LINK) {
            return (React.createElement(DbGuidePlaceUsefulLinkView_1.DbGuidePlaceUsefulLinkView, __assign({}, props.currentPlace, { onBackClick: props.onBackClick })));
        }
        if (props.currentPlace.type === DbGuideState_1.DbGuidePlaceType.BUSINESS_DIRECTORY) {
            return (React.createElement(DbGuidePlaceBusinessDirectoryView_1.DbGuidePlaceBusinessDirectoryView, __assign({}, props.currentPlace, { onBackClick: props.onBackClick })));
        }
    };
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column', height: '100%', width: '100%', position: 'absolute' } },
        React.createElement(MegaMenu_1.default, { nobottom: true }),
        React.createElement("div", { className: leftPanelClass },
            React.createElement("div", { className: "l-leftpanel__panel" },
                React.createElement("div", { className: "l-leftpanel__handle", onClick: props.onPanelToggleClicked }),
                React.createElement("div", { className: "l-leftpanel__panelbody" },
                    React.createElement("div", { id: "accordian", className: accordianClass },
                        React.createElement("div", { className: "c-guides__accordian-welcome" },
                            React.createElement("div", { className: "c-guides__welcome" },
                                React.createElement("img", { src: "https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/DBArialView.jpg", alt: "" }),
                                React.createElement("div", { className: "c-guides__welcometext" },
                                    "Your guide to living in ",
                                    React.createElement("br", null),
                                    "Discovery Bay, Hong Kong"))),
                        renderMenu(props)),
                    React.createElement("div", { id: "detail", className: detailClass }, renderCurrentPlace(props)))),
            React.createElement("div", { className: leftPanelMainClass },
                React.createElement("div", { className: "c-guides__mainaction" },
                    React.createElement("a", { className: welcomeActionClass, href: "#", onClick: props.onViewMapClicked },
                        React.createElement("span", { className: "fas fa-map" }),
                        React.createElement("span", { className: "c-guides__actiontext" }, "View Map")),
                    React.createElement("a", { onClick: onResetClick, className: nonWelcomeActionClass, href: "#" },
                        React.createElement("span", { className: "fas fa-undo" }),
                        React.createElement("span", { className: "c-guides__actiontext" }, "Reset")),
                    React.createElement("a", { onClick: onDevelopmentsFilterClick, className: nonWelcomeActionClass, href: "#" },
                        React.createElement("span", { className: "fas fa-building" }),
                        React.createElement("span", { className: "c-guides__actiontext" }, "Developments")),
                    React.createElement("a", { onClick: onSchoolsFilterClick, className: nonWelcomeActionClass, href: "#" },
                        React.createElement("span", { className: "fas fa-school" }),
                        React.createElement("span", { className: "c-guides__actiontext" }, "Schools")),
                    React.createElement("a", { onClick: onSportsFilterClick, className: nonWelcomeActionClass, href: "#" },
                        React.createElement("span", { className: "fas fa-football-ball" }),
                        React.createElement("span", { className: "c-guides__actiontext" }, "Recreation"))),
                React.createElement("div", { id: "welcome", className: "c-guides__welcome" },
                    React.createElement("img", { src: "https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/DBArialView.jpg", alt: "" }),
                    React.createElement("div", { className: "c-guides__welcometext" },
                        "Your guide to living in ",
                        React.createElement("br", null),
                        "Discovery Bay, Hong Kong")),
                React.createElement("div", { className: "c-guides__map" },
                    React.createElement(myokay_map_1.MapView, __assign({}, props.mapState, { isReady: onIsReady, onMouseevent: onMouseevent })),
                    React.createElement("div", { className: "c-guides__footer" },
                        React.createElement("a", { onClick: props.onPanelToggleClicked, className: "c-guides__footer-action js-handle", href: "#" },
                            React.createElement("span", { className: "fas fa-chevron-left" }),
                            "Back"))))),
        React.createElement(Login_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.dbGuide);
